import { createSelector } from 'reselect';
import { getSizotsaFuneralClaim } from './index';
import { FORM_STATUS } from '../../reducers/status';
import { getClaimentType } from './claimentDetails';
import { getDeceasedDetailsForm } from './deceasedDetails';
import { calculateAge } from '../../functions/easiplusFuneralPlan/Util';

export const getUploadDocuments = createSelector(
    getSizotsaFuneralClaim,
    (sizotsaFuneralClaim) => sizotsaFuneralClaim.uploadDocuments
);
export const getUploadDocumentsForm = createSelector(getUploadDocuments, (uploadDocuments) => uploadDocuments.form);

export const getUploadDocumentValidations = createSelector(getUploadDocumentsForm, (uploadDocumentsFormFields) => {
    const { proofOfBanking, beneficiaryId, affidavit, ...commonDocuments } = uploadDocumentsFormFields;
    const policyHolderDocuments = { proofOfBanking, deathCertificate: uploadDocumentsFormFields.deathCertificate,...commonDocuments };
    const beneficiaryDocuments = { beneficiaryId, ...commonDocuments };
    const executorDocuments = { affidavit, ...commonDocuments };
    return {
        Beneficiary: beneficiaryDocuments,
        'Policy holder': policyHolderDocuments,
        Executor: executorDocuments,
    };
});

export const getUploadDocumentsValid = createSelector(
    getUploadDocuments,
    (uploadDocumentsForm) => uploadDocumentsForm.formStatus === FORM_STATUS.VALID
);

const inputFieldLabels = {
    deathCertificate: 'Certified Copy Of Death Certificate',
    proofOfBanking: 'Proof Of Banking',
    beneficiaryId: 'Certified Copy Of Beneficiary ID',
    proofOfAddress: 'Proof Of Address',
    confirmationOfBankAccount: 'Confirmation Of Bank Account',
    affidavit: 'Affidavite Of The Authorize',
    letterOfMortuaryFile: 'Letter Of Mortuary',
    medicalCertificateFile: 'Medical Certificate',
    idCopyOfClaimantFile: 'ID Copy Of Claimant',
    idOfDeceasedFile: 'ID Of Deceased',
};

export const getUploadDocumentsSummary = createSelector(
    getUploadDocumentValidations,
    getClaimentType,
    getUploadDocumentsForm,
    (uploadDocumentValidation, claimentType, uploadDocumentForm) => {
        return Object.keys(uploadDocumentValidation[claimentType.displayValue])
            ?.flatMap((item) => ({
                label: inputFieldLabels[item],
                value: uploadDocumentForm[item]?.fileName ?? '-',
            }))
            .filter(({ label }) => label);
    }
);

export const getUploadDocumentArray=createSelector(getUploadDocumentValidations,getClaimentType,(uploadDocumentValidated,claimentType)=>{
  return Object.values(uploadDocumentValidated[claimentType?.displayValue])
  })